import {Dropdown as PeacockDropdown} from '@pepsico-ds/ui'
import './Dropdown.scss'
/**
 * @typedef {import('@pepsico-ds/ui').IDropdownProps} DropdownProps
 * @property {import('@pepsico-ds/ui').DropdownItem[]} childList List of dropdown options.
 * @property {boolean} [disabled] When true, dropdown is disabled.
 * @property {boolean} [readOnly] When true, dropdown is read-only.
 * @property {boolean} [error] When true, dropdown shows error state.
 * @property {import('@pepsico-ds/ui').ILabelProps | string} [label] Dropdown label configuration.
 * @property {string | import('react').ReactNode} [helperText] Helper text shown below dropdown.
 * @property {boolean} [isRequired] When true, marks dropdown as required.
 * @property {boolean} [isOptional] When true, marks dropdown as optional.
 * @property {string} [altText] Alternate required/optional text.
 * @property {string} [placeholder] Placeholder text.
 * @property {import('@pepsico-ds/ui').DropdownItem[]} [selectedValue] Selected dropdown values.
 * @property {(val: import('@pepsico-ds/ui').DropdownItem[] | undefined) => void} setSelectedValue Setter for selected value.
 * @property {'medium' | 'small'} [size] Dropdown size.
 * @property {string} [dropdownHeader] Header text shown in dropdown menu.
 * @property {'single' | 'multiple' | 'singleTreeView' | 'multipleTreeView' | 'loading'} [selection] Dropdown selection mode.
 * @property {boolean} [isClearable] When true, shows clear icon.
 * @property {boolean} [showFooter] When true, shows dropdown footer actions.
 * @property {import('@pepsico-ds/ui').IButtonHierarchyProps} [customFooterOptions] Custom footer button hierarchy props.
 * @property {boolean} [hideMenuListOnSelection] When true, hides menu on selection.
 * @property {'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'} [menuPosition] Dropdown menu position.
 * @property {boolean} [skeleton] Renders skeleton state.
 * @property {boolean} [showInLineFeedback] When true, shows inline feedback.
 * @property {boolean} [showLabelIcon] When true, shows label icon.
 * @property {string} [customNoResultMessage] Custom empty search result message.
 * @property {(value: string) => void} [onSearchInputChange] Callback for search input changes.
 * @property {Partial<import('@pepsico-ds/ui').ITooltipProps>} [tooltipProps] Tooltip props for truncation tooltip.
 * @property {boolean} [usePortal] When true, renders menu inside a portal.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS Dropdown.
 * Supports all Peacock DS dropdown props.
 * @param {DropdownProps} props
 */

export const Dropdown = props => {
  return <PeacockDropdown {...props} />
}
